import { useState } from "react";
import { bool, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useEstimateEditorStore, useEstimateStructure } from "@tools";
import { Alert } from "@components";
import { IconButton, Tooltip } from "@material-ui/core";
import { Add } from "@material-ui/icons";

export const NewDescriptionButton = observer(({
  section,
  usedAllDescriptionColumns,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { hasCreatedDescription, setCreatedDescription } = useEstimateEditorStore();

  const [ fullAlertVisible, showFullAlert ] = useState(false);

  const handleAdd = () => {
    if (usedAllDescriptionColumns) {
      showFullAlert(true);
      return;
    }

    structure.historyManager.startGroup();
    section.addTemporaryDescriptionColumn();
    setCreatedDescription(true);
  };

  return (
    <>
      <Tooltip title={t("views.editor.breakdown_table.add_description_column")}>
        <IconButton
          onClick={handleAdd}
          size="tiny"
          color="primary"
          className="text-sm p-0-5 ml-1"
          disabled={hasCreatedDescription}
        >
          <Add />
        </IconButton>
      </Tooltip>
      <Alert
        title={t("views.editor.breakdown_table.alert_titles.full")}
        isOpen={fullAlertVisible}
        acceptText={t("common.close")}
        onAccept={() => showFullAlert(false)}
        width={410}
      >
        {t("views.editor.breakdown_table.alert_titles.full_content")}
      </Alert>
    </>
  );
});

NewDescriptionButton.propTypes = {
  section: object.isRequired,
  usedAllDescriptionColumns: bool,
};
